<template >
  <div class="userDialog">
    <el-dialog :title="title" :visible.sync="show" :before-close="closePaperSetting" width="500px">
      <el-form ref="applyForm" :model="applyForm" :rules="rules">
        <el-form-item  class="is-required" prop="remark" >
          <el-input v-model.trim="applyForm.remark"  maxlength="200" placeholder="请输入填写备注信息..." type="textarea" rows="5"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePaperSetting">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import devService from '../../../../service/devService'
export default {
  props: {
    dataform: {
      type: Object
    }
  },
  data () {
    return {
      title: '备注',
      loading: false,
      applyForm: {},
      rules: {
        remark: [
          { required: true, message: '请输入填写备注信息', trigger: 'blur' }
        ]
      },
      show: true
    }
  },
  mounted () {
    this.applyForm = JSON.parse(JSON.stringify(this.dataform))
  },
  methods: {
    closePaperSetting () {
      this.$emit('hide')
    },
    save () {
      this.loading = true
      this.$refs.applyForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            await devService.updateRemark(this.applyForm)
            // 重置表单
            this.$emit('success', this.applyForm.remark)
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  }
}
</script>
<style type="text/css">
 .userDialog .el-input__inner{
   color: #333333;
 }

</style>



// WEBPACK FOOTER //
// src/pages/admin/applyuser-manage/edit-dialog/index.vue